// 菜单，顶栏

export default [
  {
    path: "/bpm/my/todoTaskList",
    title: "南康区民意速办综合管理平台",
    //icon: 'md-home',
    hideSider: true,
    name: "home",
  },
];
